module.exports = __webpack_public_path__ + "static/media/vigold.6d3c074d.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/climasense/blackdot_antracnosis_papa/curativa/vigold.png
// module id = 1996
// module chunks = 3